import dayjs from "dayjs";

export type DashboardDateRange = [Date | null, Date | null];

/** Inclusive window ending today. `days` is the span people name ("last 90 days"). */
export const dashboardRangeEndingToday = (days: number): DashboardDateRange => [
  dayjs()
    .subtract(days - 1, "day")
    .toDate(),
  dayjs().toDate(),
];

export const formatDashboardRangeLabel = (
  range: DashboardDateRange,
): string => {
  const [start, end] = range;
  if (!start || !end) {
    return "Select range";
  }

  if (dayjs(end).isSame(dayjs(), "day")) {
    const span = dayjs(end)
      .startOf("day")
      .diff(dayjs(start).startOf("day"), "day");
    if (span === 29 || span === 30) {
      return "Last 30 days";
    }
    if (span === 89 || span === 90) {
      return "Last 90 days";
    }
  }

  const sameYear = dayjs(start).year() === dayjs(end).year();
  const startText = dayjs(start).format(sameYear ? "D MMM" : "D MMM YYYY");
  const endText = dayjs(end).format("D MMM YYYY");
  return `${startText} – ${endText}`;
};
